const gql = require("graphql-tag");

const ROLE = gql`
  query ($data: RolesFindInput!) {
    Roles(data: $data) {
      id
      type
      isActive
    }
  }
`;

const PERSONS = gql`
  query ($data: PersonsFindInput!) {
    Persons(data: $data) {
      id
      roleUser {
        id
        username
        name
        surname
        isActive
      }
      type
      company {
        id
        name
        description
        isActive
      }
      isActive
      createdAt
    }
  }
`;

const ROLES_MY = gql`
  query ($data: RolesFindInput) {
    Roles(data: $data) {
      company {
        id
        name
      }
      type
      isActive
    }
  }
`;

const PERSONS_DROPPDOWN = gql`
  query ($data: PersonsFindInput!) {
    Persons(data: $data) {
      roleUser {
        id
        name
        surname
        isActive
      }
    }
  }
`;

export const rolesQueries = {
  ROLES_MY,
  ROLE,
  PERSONS,
  PERSONS_DROPPDOWN,
};
